export default __webpack_public_path__ + "static/media/cover (4).35fb343b.svg";